webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RECEIVE_PROJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RECEIVE_PERSONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_PERSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RECEIVE_NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RECEIVE_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RECEIVE_INVESTORS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_INVESTORS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RECEIVE_INVESTORS_GEOGRAPHIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_INVESTORS_GEOGRAPHIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_MENU_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CURRENT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_CURRENT_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CURRENT_PERSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_CURRENT_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_CURRENT_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_POPUP_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_FADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_IS_AUTO_SCROLLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_ERROR_PAGE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADED_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return READY_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return IS_MOBILE; });
var RECEIVE_PROJECTS = 'RECEIVE_PROJECTS';
var FETCH_PROJECT = 'FETCH_PROJECT';
var RECEIVE_PERSONS = 'RECEIVE_PERSONS';
var FETCH_PERSON = 'FETCH_PERSON';
var RECEIVE_NEWS = 'RECEIVE_NEWS';
var FETCH_ARTICLE = 'FETCH_ARTICLE';
var RECEIVE_NAVIGATION = 'RECEIVE_NAVIGATION';
var RECEIVE_PAGE = 'RECEIVE_PAGE';
var RECEIVE_INVESTORS_TYPES = 'RECEIVE_INVESTORS_TYPES';
var FETCH_INVESTORS_TYPES = 'FETCH_INVESTORS_TYPES';
var RECEIVE_INVESTORS_GEOGRAPHIES = 'RECEIVE_INVESTORS_GEOGRAPHIES';
var FETCH_INVESTORS_GEOGRAPHIES = 'FETCH_INVESTORS_GEOGRAPHIES';
var CHANGE_MENU_STATE = 'CHANGE_MENU_STATE';
var SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
var SET_CURRENT_TAB = 'SET_CURRENT_TAB';
var SET_CURRENT_PERSON = 'SET_CURRENT_PERSON';
var SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
var SET_CURRENT_ARTICLE = 'SET_CURRENT_ARTICLE';
var SET_POPUP_STATE = 'SET_POPUP_STATE';
var SET_FADER = 'SET_FADER';
var PAGE_IS_AUTO_SCROLLING = 'PAGE_IS_AUTO_SCROLLING';
var SET_ERROR_PAGE_STATE = 'SET_ERROR_PAGE_STATE';
var LOADED_PAGE = 'LOADED_PAGE';
var READY_PAGE = 'READY_PAGE';
var SET_LANG = 'SET_LANG';
var IS_MOBILE = 'IS_MOBILE';

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eae867dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PageTitle_vue__ = __webpack_require__(212);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eae867dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PageTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function browserDetect() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('edge') > -1) {
    return 'edge';
  }
  if (/ipad|iphone|ipod/.test(ua) && !window.MSStream) {
    return 'ios';
  }
  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      return 'chrome';
    }
    return 'safari';
  }
  if (ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1) {
    return 'ie';
  }
  if (ua.indexOf('firefox') > -1) {
    return 'mozilla';
  }
  return 'standard';
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29701545_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29701545"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29701545_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitleContent_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa7a5892_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PageTitleContent_vue__ = __webpack_require__(213);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitleContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa7a5892_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PageTitleContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function prettifyDay(day) {
  var splitNum = day.toString().split('');
  var firstNum = splitNum[0];
  var secondNum = splitNum[1];
  var newNum = '';

  if (firstNum === '0') {
    newNum = secondNum;
  } else {
    newNum = day;
  }
  return newNum;
};

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

module.exports = {
  en: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },
  ru: {
    months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
  }
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ErrorPage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ErrorServer__ = __webpack_require__(163);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  // scrollBehavior: (to) => {
  //   if (to.hash) {
  //     return { selector: to.hash };
  //   }
  //   return { x: 0, y: 0 };
  // },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/about/',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/founders/',
    name: 'Founders',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/team/',
    name: 'Team',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/portfolio/',
    name: 'Portfolio',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/news/',
    name: 'News',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/privateequity/',
    name: 'PrivateEquity',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/contacts/',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/500/',
    name: 'ErrorServer',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_ErrorServer__["a" /* default */]
  }, {
    path: '*',
    name: 'ErrorPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_ErrorPage__["a" /* default */]
  }]
}));

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_navigation__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_projects__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_persons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_news__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_investorsTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_investorsGeographies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_page__ = __webpack_require__(43);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    navigation: __WEBPACK_IMPORTED_MODULE_2__store_modules_navigation__["a" /* default */],
    projects: __WEBPACK_IMPORTED_MODULE_3__store_modules_projects__["a" /* default */],
    persons: __WEBPACK_IMPORTED_MODULE_4__store_modules_persons__["a" /* default */],
    news: __WEBPACK_IMPORTED_MODULE_5__store_modules_news__["a" /* default */],
    investorsTypes: __WEBPACK_IMPORTED_MODULE_6__store_modules_investorsTypes__["a" /* default */],
    investorsGeographies: __WEBPACK_IMPORTED_MODULE_7__store_modules_investorsGeographies__["a" /* default */],
    page: __WEBPACK_IMPORTED_MODULE_8__store_modules_page__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1398aa8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1398aa8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = function checkAllImages(self) {
  function isImageOk(img) {
    if (!img.complete) {
      return false;
    }

    if (typeof img.naturalWidth !== 'undefined' && img.naturalWidth === 0) {
      return false;
    }
    return true;
  }
  var images = document.querySelector('img');
  var imagesLoaded = 0;
  if (images && images.length) {
    var waitImages = setInterval(function () {
      imagesLoaded = 0;
      for (var img = 0; img < images.length; img += 1) {
        if (isImageOk(images[img])) imagesLoaded += 1;
      }
      if (imagesLoaded === images.length) {
        clearInterval(waitImages);
        self.$store.commit('LOADED_PAGE', true);
      }
    }, 50);
  }
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function getKeyByValue(obj, id) {
  for (var i = 0; i < obj.length; i += 1) {
    if (obj[i].parent_id === id) return true;
  }
  return false;
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sticky__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_animate_number__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_animate_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_animate_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_i18n__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuebar__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_lang_labels__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_lang_labels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_lang_labels__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_animate_number___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vuebar___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('sticky', __WEBPACK_IMPORTED_MODULE_5_vue_sticky___default.a);

var i18n = new __WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]({
  locale: 'en', // set locale
  messages: __WEBPACK_IMPORTED_MODULE_13__assets_lang_labels___default.a // set locale messages
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */] }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);


var _mutations;



// initial state
var state = {
  investorsGeographies: [],
  investorsGeography: {}
};

// getters
var getters = {
  investorsGeographies: function investorsGeographies(stateFreezed) {
    return stateFreezed.investorsGeographies;
  },
  investorsGeography: function investorsGeography(stateFreezed) {
    return stateFreezed.investorsGeography;
  }
};

// actions
var actions = {
  fetchInvestorsGeographies: function fetchInvestorsGeographies(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/api/investorsgeographies/').then(function (response) {
      if (response.body.content && response.body.content.investors_geography) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* RECEIVE_INVESTORS_GEOGRAPHIES */], response.body.content.investors_geography);
      }
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* RECEIVE_INVESTORS_GEOGRAPHIES */], function (stateFreezed, investorsGeographyFetched) {
  var st = stateFreezed;
  st.investorsGeographies = investorsGeographyFetched.list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* FETCH_INVESTORS_GEOGRAPHIES */], function (stateFreezed, investorsGeography) {
  var st = stateFreezed;
  st.investorsGeography = st.investorsGeography.item.find(function (o) {
    return o.$slug === investorsGeography;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);


var _mutations;



// initial state
var state = {
  investorsTypes: [],
  investorsType: {}
};

// getters
var getters = {
  investorsTypes: function investorsTypes(stateFreezed) {
    return stateFreezed.investorsTypes;
  },
  investorsType: function investorsType(stateFreezed) {
    return stateFreezed.investorsType;
  }
};

// actions
var actions = {
  fetchInvestorsTypes: function fetchInvestorsTypes(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/api/investorstypes/').then(function (response) {
      if (response.body.content && response.body.content.investors_type) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* RECEIVE_INVESTORS_TYPES */], response.body.content.investors_type);
      }
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* RECEIVE_INVESTORS_TYPES */], function (stateFreezed, investorsTypeFetched) {
  var st = stateFreezed;
  st.investorsTypes = investorsTypeFetched.list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* FETCH_INVESTORS_TYPES */], function (stateFreezed, investorsType) {
  var st = stateFreezed;
  st.investorsType = st.investorsType.item.find(function (o) {
    return o.$slug === investorsType;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);



// initial state
var state = {
  menu: {},
  theme: ''
};

// getters
var getters = {
  navigation: function navigation(stateFreezed) {
    return stateFreezed.menu;
  },
  navigationTheme: function navigationTheme(stateFreezed) {
    return stateFreezed.theme;
  }
};

// actions
var actions = {
  fetchNavigation: function fetchNavigation(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/api/navigation/').then(function (response) {
      // get body data
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["z" /* RECEIVE_NAVIGATION */], response.body.navigation);
    });
  }
};

// mutations
var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["z" /* RECEIVE_NAVIGATION */], function (stateFreezed, navFetched) {
  var st = stateFreezed;
  st.menu = navFetched;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);


var _mutations;



// initial state
var state = {
  news: [],
  article: {}
};

// getters
var getters = {
  news: function news(stateFreezed) {
    return stateFreezed.news;
  },
  article: function article(stateFreezed) {
    return stateFreezed.article;
  }
};

// actions
var actions = {
  fetchNews: function fetchNews(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/api/news/').then(function (response) {
      if (response.body.content && response.body.content.article) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["t" /* RECEIVE_NEWS */], response.body.content.article);
      }
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["t" /* RECEIVE_NEWS */], function (stateFreezed, articleFetched) {
  var st = stateFreezed;
  st.news = articleFetched.list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["u" /* FETCH_ARTICLE */], function (stateFreezed, article) {
  var st = stateFreezed;
  st.article = st.news.item.find(function (o) {
    return o.$slug === article;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(2);


var _mutations;




var device = function device() {
  var detector = new __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default.a(window.navigator.userAgent);
  return detector;
};

// initial state
var state = {
  page: {},
  pageLoaded: false,
  pageReady: false,
  lang: 'en',
  menuExpanded: false,
  currentPage: 'home',
  currentTab: 'company',
  currentPerson: '',
  currentProject: '',
  currentArticleIndex: '',
  pageIsAutoScrolling: false,
  popupOpened: false,
  fader: false,
  isErrorPage: false,
  mobile: device().mobile()
};

// getters
var getters = {
  page: function page(stateFreezed) {
    return stateFreezed.page;
  },
  pageLoaded: function pageLoaded(stateFreezed) {
    return stateFreezed.pageLoaded;
  },
  pageReady: function pageReady(stateFreezed) {
    return stateFreezed.pageReady;
  },
  lang: function lang(stateFreezed) {
    return stateFreezed.lang;
  },
  menuExpanded: function menuExpanded(stateFreezed) {
    return stateFreezed.menuExpanded;
  },
  currentPage: function currentPage(stateFreezed) {
    return stateFreezed.currentPage;
  },
  currentTab: function currentTab(stateFreezed) {
    return stateFreezed.currentTab;
  },
  currentPerson: function currentPerson(stateFreezed) {
    return stateFreezed.currentPerson;
  },
  currentProject: function currentProject(stateFreezed) {
    return stateFreezed.currentProject;
  },
  currentArticleIndex: function currentArticleIndex(stateFreezed) {
    return stateFreezed.currentArticleIndex;
  },
  pageIsAutoScrolling: function pageIsAutoScrolling(stateFreezed) {
    return stateFreezed.pageIsAutoScrolling;
  },
  popupOpened: function popupOpened(stateFreezed) {
    return stateFreezed.popupOpened;
  },
  fader: function fader(stateFreezed) {
    return stateFreezed.fader;
  },
  isErrorPage: function isErrorPage(stateFreezed) {
    return stateFreezed.isErrorPage;
  },
  mobile: function mobile(stateFreezed) {
    return stateFreezed.mobile;
  }
};

// actions
var actions = {
  fetchPage: function fetchPage(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/pages/').then(function (response) {
      // get body data
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* RECEIVE_PAGE */], response.body.content);
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* RECEIVE_PAGE */], function (stateFreezed, pageFetched) {
  var st = stateFreezed;
  st.page = pageFetched;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* LOADED_PAGE */], function (stateFreezed, loaded) {
  var st = stateFreezed;
  st.pageLoaded = loaded;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* READY_PAGE */], function (stateFreezed, ready) {
  var st = stateFreezed;
  st.pageReady = ready;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_LANG */], function (stateFreezed, lang) {
  var st = stateFreezed;
  st.lang = lang;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* PAGE_IS_AUTO_SCROLLING */], function (stateFreezed, scroll) {
  var st = stateFreezed;
  st.pageIsAutoScrolling = scroll;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* CHANGE_MENU_STATE */], function (stateFreezed, menuState) {
  var st = stateFreezed;
  st.menuExpanded = menuState;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* SET_CURRENT_PAGE */], function (stateFreezed, current) {
  var st = stateFreezed;
  // const currentTitle = current.replace('-content', '');
  // const currentTitleCapitalized = currentTitle.charAt(0).toUpperCase() + currentTitle.slice(1);
  // document.title = currentTitleCapitalized;
  st.currentPage = current;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SET_CURRENT_TAB */], function (stateFreezed, current) {
  var st = stateFreezed;
  st.currentTab = current;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_CURRENT_PERSON */], function (stateFreezed, current) {
  var st = stateFreezed;
  st.currentPerson = current;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SET_CURRENT_PROJECT */], function (stateFreezed, current) {
  var st = stateFreezed;
  st.currentProject = current;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* SET_CURRENT_ARTICLE */], function (stateFreezed, current) {
  var st = stateFreezed;
  st.currentArticleIndex = current;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* SET_POPUP_STATE */], function (stateFreezed, popupState) {
  var st = stateFreezed;
  st.popupOpened = popupState;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_ERROR_PAGE_STATE */], function (stateFreezed, errorState) {
  var st = stateFreezed;
  st.isErrorPage = errorState;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* SET_FADER */], function (stateFreezed, faderState) {
  var st = stateFreezed;
  document.body.className = faderState ? 'with-overflow-hidden' : '';
  st.fader = faderState;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* IS_MOBILE */], function (stateFreezed, isMobile) {
  var st = stateFreezed;
  st.mobile = isMobile || device().mobile();
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);


var _mutations;



// initial state
var state = {
  persons: [],
  person: {}
};

// getters
var getters = {
  persons: function persons(stateFreezed) {
    return stateFreezed.persons;
  },
  person: function person(stateFreezed) {
    return stateFreezed.person;
  }
};

// actions
var actions = {
  fetchPersons: function fetchPersons(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/api/persons/').then(function (response) {
      if (response.body.content && response.body.content.person) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* RECEIVE_PERSONS */], response.body.content.person);
      }
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* RECEIVE_PERSONS */], function (stateFreezed, personsFetched) {
  var st = stateFreezed;
  st.persons = personsFetched.list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["w" /* FETCH_PERSON */], function (stateFreezed, person) {
  var st = stateFreezed;
  st.person = st.persons.item.find(function (o) {
    return o.$slug === person;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);


var _mutations;



// initial state
var state = {
  projects: [],
  project: {}
};

// getters
var getters = {
  projects: function projects(stateFreezed) {
    return stateFreezed.projects;
  },
  project: function project(stateFreezed) {
    return stateFreezed.project;
  }
};

// actions
var actions = {
  fetchProjects: function fetchProjects(_ref, params) {
    var commit = _ref.commit;

    params.$http.get('/' + params.lang + '/api/projects/').then(function (response) {
      if (response.body.content && response.body.content.project) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["x" /* RECEIVE_PROJECTS */], response.body.content.project);
      }
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["x" /* RECEIVE_PROJECTS */], function (stateFreezed, projectFetched) {
  var st = stateFreezed;
  st.projects = projectFetched.list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["y" /* FETCH_PROJECT */], function (stateFreezed, project) {
  var st = stateFreezed;
  st.project = st.projects.item.find(function (o) {
    return o.$slug === project;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(22);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShow: false
    };
  },
  props: {
    width: {
      required: true,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    height: {
      required: true,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    order: {
      default: 0
    },
    moveClass: {
      default: ''
    }
  },
  methods: {
    notify: function notify() {
      this.$parent.$emit('reflow', this);
    },
    getMeta: function getMeta() {
      return {
        vm: this,
        node: this.$el,
        order: this.order,
        width: this.width,
        height: this.height,
        moveClass: this.moveClass
      };
    }
  },
  created: function created() {
    var _this = this;

    this.rect = {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    };
    this.$watch(function () {
      return _this.width, _this.height;
    }, this.notify);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$parent.$once('reflowed', function () {
      _this2.isShow = true;
    });
    this.notify();
  },
  destroyed: function destroyed() {
    this.notify();
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//


var MOVE_CLASS_PROP = '_wfMoveClass';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoResize: {
      default: true
    },
    interval: {
      default: 200,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    align: {
      default: 'left',
      validator: function validator(val) {
        return ~['left', 'right', 'center'].indexOf(val);
      }
    },
    line: {
      default: 'v',
      validator: function validator(val) {
        return ~['v', 'h'].indexOf(val);
      }
    },
    lineGap: {
      required: true,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    minLineGap: {
      validator: function validator(val) {
        return val >= 0;
      }
    },
    maxLineGap: {
      validator: function validator(val) {
        return val >= 0;
      }
    },
    singleMaxWidth: {
      validator: function validator(val) {
        return val >= 0;
      }
    },
    fixedHeight: {
      default: false
    },
    grow: {
      validator: function validator(val) {
        return val instanceof Array;
      }
    },
    watch: {
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      style: {
        height: '',
        overflow: ''
      },
      token: null
    };
  },
  methods: {
    reflowHandler: reflowHandler,
    autoResizeHandler: autoResizeHandler,
    reflow: reflow
  },
  created: function created() {
    var _this = this;

    this.virtualRects = [];
    this.$on('reflow', function () {
      _this.reflowHandler();
    });
    this.$watch(function () {
      return _this.align, _this.line, _this.lineGap, _this.minLineGap, _this.maxLineGap, _this.singleMaxWidth, _this.fixedHeight, _this.watch;
    }, this.reflowHandler);
    this.$watch('grow', this.reflowHandler);
  },
  mounted: function mounted() {
    this.$watch('autoResize', this.autoResizeHandler);
    on(this.$el, getTransitionEndEvent(), tidyUpAnimations, true);
    this.autoResizeHandler(this.autoResize);
  },
  beforeDestroy: function beforeDestroy() {
    this.autoResizeHandler(false);
    off(this.$el, getTransitionEndEvent(), tidyUpAnimations, true);
  }
});

function autoResizeHandler(autoResize) {
  if (autoResize === false || !this.autoResize) {
    off(window, 'resize', this.reflowHandler, false);
  } else {
    on(window, 'resize', this.reflowHandler, false);
  }
}

function tidyUpAnimations(event) {
  var node = event.target;
  var moveClass = node[MOVE_CLASS_PROP];
  if (moveClass) {
    removeClass(node, moveClass);
  }
}

function reflowHandler() {
  clearTimeout(this.token);
  this.token = setTimeout(this.reflow, this.interval);
}

function reflow() {
  var _this2 = this;

  if (!this.$el) {
    return;
  }
  var width = this.$el.clientWidth;
  var metas = this.$children.map(function (slot) {
    return slot.getMeta();
  });
  metas.sort(function (a, b) {
    return a.order - b.order;
  });
  this.virtualRects = metas.map(function () {
    return {};
  });
  calculate(this, metas, this.virtualRects);
  setTimeout(function () {
    if (isScrollBarVisibilityChange(_this2.$el, width)) {
      calculate(_this2, metas, _this2.virtualRects);
    }
    _this2.style.overflow = 'hidden';
    render(_this2.virtualRects, metas);
    _this2.$emit('reflowed', _this2);
  }, 0);
}

function isScrollBarVisibilityChange(el, lastClientWidth) {
  return lastClientWidth !== el.clientWidth;
}

function calculate(vm, metas, styles) {
  var options = getOptions(vm);
  var processor = vm.line === 'h' ? horizontalLineProcessor : verticalLineProcessor;
  processor.calculate(vm, options, metas, styles);
}

function getOptions(vm) {
  var maxLineGap = vm.maxLineGap ? +vm.maxLineGap : vm.lineGap;
  return {
    align: ~['left', 'right', 'center'].indexOf(vm.align) ? vm.align : 'left',
    line: ~['v', 'h'].indexOf(vm.line) ? vm.line : 'v',
    lineGap: +vm.lineGap,
    minLineGap: vm.minLineGap ? +vm.minLineGap : vm.lineGap,
    maxLineGap: maxLineGap,
    singleMaxWidth: Math.max(vm.singleMaxWidth || 0, maxLineGap),
    fixedHeight: !!vm.fixedHeight,
    grow: vm.grow && vm.grow.map(function (val) {
      return +val;
    })
  };
}

var verticalLineProcessor = function () {

  function calculate(vm, options, metas, rects) {
    var width = vm.$el.clientWidth;
    var grow = options.grow;
    var strategy = grow ? getRowStrategyWithGrow(width, grow) : getRowStrategy(width, options);
    var tops = getArrayFillWith(0, strategy.count);
    metas.forEach(function (meta, index) {
      var offset = tops.reduce(function (last, top, i) {
        return top < tops[last] ? i : last;
      }, 0);
      var width = strategy.width[offset % strategy.count];
      var rect = rects[index];
      rect.top = tops[offset];
      rect.left = strategy.left + (offset ? sum(strategy.width.slice(0, offset)) : 0);
      rect.width = width;
      rect.height = meta.height * (options.fixedHeight ? 1 : width / meta.width);
      tops[offset] = tops[offset] + rect.height;
    });
    vm.style.height = Math.max.apply(Math, tops) + 'px';
  }

  function getRowStrategy(width, options) {
    var count = width / options.lineGap;
    var slotWidth = void 0;
    if (options.singleMaxWidth >= width) {
      count = 1;
      slotWidth = Math.max(width, options.minLineGap);
    } else {
      var maxContentWidth = options.maxLineGap * ~~count;
      var minGreedyContentWidth = options.minLineGap * ~~(count + 1);
      var canFit = maxContentWidth >= width;
      var canFitGreedy = minGreedyContentWidth <= width;
      if (canFit && canFitGreedy) {
        count = Math.round(count);
        slotWidth = width / count;
      } else if (canFit) {
        count = ~~count;
        slotWidth = width / count;
      } else if (canFitGreedy) {
        count = ~~(count + 1);
        slotWidth = width / count;
      } else {
        count = ~~count;
        slotWidth = options.maxLineGap;
      }
      if (count === 1) {
        slotWidth = Math.min(width, options.singleMaxWidth);
        slotWidth = Math.max(slotWidth, options.minLineGap);
      }
    }
    return {
      width: getArrayFillWith(slotWidth, count),
      count: count,
      left: getLeft(width, slotWidth * count, options.align)
    };
  }

  function getRowStrategyWithGrow(width, grow) {
    var total = sum(grow);
    return {
      width: grow.map(function (val) {
        return width * val / total;
      }),
      count: grow.length,
      left: 0
    };
  }

  return {
    calculate: calculate
  };
}();

var horizontalLineProcessor = function () {

  function calculate(vm, options, metas, rects) {
    var width = vm.$el.clientWidth;
    var total = metas.length;
    var top = 0;
    var offset = 0;
    while (offset < total) {
      var strategy = getRowStrategy(width, options, metas, offset);
      for (var i = 0, left = 0, meta, rect; i < strategy.count; i++) {
        meta = metas[offset + i];
        rect = rects[offset + i];
        rect.top = top;
        rect.left = strategy.left + left;
        rect.width = meta.width * strategy.height / meta.height;
        rect.height = strategy.height;
        left += rect.width;
      }
      offset += strategy.count;
      top += strategy.height;
    }
    vm.style.height = top + 'px';
  }

  function getRowStrategy(width, options, metas, offset) {
    var greedyCount = getGreedyCount(width, options.lineGap, metas, offset);
    var lazyCount = Math.max(greedyCount - 1, 1);
    var greedySize = getContentSize(width, options, metas, offset, greedyCount);
    var lazySize = getContentSize(width, options, metas, offset, lazyCount);
    var finalSize = chooseFinalSize(lazySize, greedySize, width);
    var height = finalSize.height;
    var fitContentWidth = finalSize.width;
    if (finalSize.count === 1) {
      fitContentWidth = Math.min(options.singleMaxWidth, width);
      height = metas[offset].height * fitContentWidth / metas[offset].width;
    }
    return {
      left: getLeft(width, fitContentWidth, options.align),
      count: finalSize.count,
      height: height
    };
  }

  function getGreedyCount(rowWidth, rowHeight, metas, offset) {
    var count = 0;
    for (var i = offset, width = 0; i < metas.length && width <= rowWidth; i++) {
      width += metas[i].width * rowHeight / metas[i].height;
      count++;
    }
    return count;
  }

  function getContentSize(rowWidth, options, metas, offset, count) {
    var originWidth = 0;
    for (var i = count - 1; i >= 0; i--) {
      var meta = metas[offset + i];
      originWidth += meta.width * options.lineGap / meta.height;
    }
    var fitHeight = options.lineGap * rowWidth / originWidth;
    var canFit = fitHeight <= options.maxLineGap && fitHeight >= options.minLineGap;
    if (canFit) {
      return {
        cost: Math.abs(options.lineGap - fitHeight),
        count: count,
        width: rowWidth,
        height: fitHeight
      };
    } else {
      var height = originWidth > rowWidth ? options.minLineGap : options.maxLineGap;
      return {
        cost: Infinity,
        count: count,
        width: originWidth * height / options.lineGap,
        height: height
      };
    }
  }

  function chooseFinalSize(lazySize, greedySize, rowWidth) {
    if (lazySize.cost === Infinity && greedySize.cost === Infinity) {
      return greedySize.width < rowWidth ? greedySize : lazySize;
    } else {
      return greedySize.cost >= lazySize.cost ? lazySize : greedySize;
    }
  }

  return {
    calculate: calculate
  };
}();

function getLeft(width, contentWidth, align) {
  switch (align) {
    case 'right':
      return width - contentWidth;
    case 'center':
      return (width - contentWidth) / 2;
    default:
      return 0;
  }
}

function sum(arr) {
  return arr.reduce(function (sum, val) {
    return sum + val;
  });
}

function render(rects, metas) {
  var metasNeedToMoveByTransform = metas.filter(function (meta) {
    return meta.moveClass;
  });
  var firstRects = getRects(metasNeedToMoveByTransform);
  applyRects(rects, metas);
  var lastRects = getRects(metasNeedToMoveByTransform);
  metasNeedToMoveByTransform.forEach(function (meta, i) {
    meta.node[MOVE_CLASS_PROP] = meta.moveClass;
    setTransform(meta.node, firstRects[i], lastRects[i]);
  });
  document.body.clientWidth; // forced reflow
  metasNeedToMoveByTransform.forEach(function (meta) {
    addClass(meta.node, meta.moveClass);
    clearTransform(meta.node);
  });
}

function getRects(metas) {
  return metas.map(function (meta) {
    return meta.vm.rect;
  });
}

function applyRects(rects, metas) {
  rects.forEach(function (rect, i) {
    var style = metas[i].node.style;
    metas[i].vm.rect = rect;
    for (var prop in rect) {
      style[prop] = rect[prop] + 'px';
    }
  });
}

function setTransform(node, firstRect, lastRect) {
  var dx = firstRect.left - lastRect.left;
  var dy = firstRect.top - lastRect.top;
  var sw = firstRect.width / lastRect.width;
  var sh = firstRect.height / lastRect.height;
  node.style.transform = node.style.WebkitTransform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sw + ',' + sh + ')';
  node.style.transitionDuration = '0s';
}

function clearTransform(node) {
  node.style.transform = node.style.WebkitTransform = '';
  node.style.transitionDuration = '';
}

function getTransitionEndEvent() {
  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
  var transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
  return transitionEndEvent;
}

/**
 * util
 */

function getArrayFillWith(item, count) {
  var getter = typeof item === 'function' ? function () {
    return item();
  } : function () {
    return item;
  };
  var arr = [];
  for (var i = 0; i < count; i++) {
    arr[i] = getter();
  }
  return arr;
}

function addClass(elem, name) {
  if (!hasClass(elem, name)) {
    var cur = attr(elem, 'class').trim();
    var res = (cur + ' ' + name).trim();
    attr(elem, 'class', res);
  }
}

function removeClass(elem, name) {
  var reg = new RegExp('\\s*\\b' + name + '\\b\\s*', 'g');
  var res = attr(elem, 'class').replace(reg, ' ').trim();
  attr(elem, 'class', res);
}

function hasClass(elem, name) {
  return new RegExp('\\b' + name + '\\b').test(attr(elem, 'class'));
}

function attr(elem, name, value) {
  if (typeof value !== 'undefined') {
    elem.setAttribute(name, value);
  } else {
    return elem.getAttribute(name) || '';
  }
}

function on(elem, type, listener) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  elem.addEventListener(type, listener, useCapture);
}

function off(elem, type, listener) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  elem.removeEventListener(type, listener, useCapture);
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderComponent__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_checkAllImages__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_checkAllImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helpers_checkAllImages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_browserDetect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_browserDetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helpers_browserDetect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    page: 'page',
    pageReady: 'pageReady',
    pageLoaded: 'pageLoaded',
    isErrorPage: 'isErrorPage',
    currentPage: 'currentPage',
    pageIsAutoScrolling: 'pageIsAutoScrolling'
  }),
  data: function data() {
    return {
      sections: [],
      browser: __WEBPACK_IMPORTED_MODULE_3__helpers_browserDetect___default()()
    };
  },

  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_HeaderComponent__["a" /* default */]
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.detectCurrentPage);
    __WEBPACK_IMPORTED_MODULE_2__helpers_checkAllImages___default()();
  },

  watch: {
    pageIsAutoScrolling: function pageIsAutoScrolling() {
      this.detectCurrentPage();
    }
  },
  methods: {
    detectPageContainers: function detectPageContainers() {
      if (this.sections.length < 5) {
        this.sections = document.querySelectorAll('.section');
      }
    },
    detectCurrentPage: function detectCurrentPage() {
      if (this.pageIsAutoScrolling) return;
      var currentTop = window.pageYOffset;
      var currentMiddle = currentTop + window.innerHeight / 2;

      var parentId = '';
      var isActive = void 0;

      this.detectPageContainers();

      for (var i = 0; i < this.sections.length; i += 1) {
        var elemTop = this.sections[i].offsetTop;

        if (currentMiddle >= elemTop) {
          isActive = this.sections[i];
        }
      }

      if (!isActive) {
        parentId = 'home';
      } else {
        parentId = isActive.parentElement.id;
      }
      if (parentId !== this.currentPage) {
        this.$store.commit('SET_CURRENT_PAGE', parentId);
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pageTitle',
  props: ['descrValue', 'isActive'],
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    pageReady: 'pageReady'
  })
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footerComponent',
  data: function data() {
    return {};
  },

  props: ['copyright', 'madeIn'],
  methods: {}
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navigation__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Langs__ = __webpack_require__(150);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'headerComponent',
  data: function data() {
    return {
      reducedMenu: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    page: 'page',
    menuExpanded: 'menuExpanded'
  }),
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_1__components_Navigation__["a" /* default */],
    Langs: __WEBPACK_IMPORTED_MODULE_2__components_Langs__["a" /* default */]
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.reduceMenu);
  },

  methods: {
    expandMenu: function expandMenu() {
      this.$store.commit('CHANGE_MENU_STATE', !this.menuExpanded);
    },
    reduceMenu: function reduceMenu() {
      var winCurrentTop = window.pageYOffset;
      if (winCurrentTop > 0 && !this.reducedMenu) {
        this.reducedMenu = true;
      }
      if (winCurrentTop === 0 && this.reducedMenu) {
        this.reducedMenu = false;
      }
    },
    scrollToTop: function scrollToTop() {
      this.$SmoothScroll(0, 500);
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'investors',
  props: ['content'],
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    investorsTypes: 'investorsTypes',
    investorsGeographies: 'investorsGeographies'
  }),
  data: function data() {
    return {
      rand: [],
      typesAnimation: false
    };
  },

  watch: {
    lang: function lang() {
      this.getData();
    }
  },
  methods: {
    getData: function getData() {
      this.$store.dispatch('fetchInvestorsTypes', { lang: this.lang, $http: this.$http });
      this.$store.dispatch('fetchInvestorsGeographies', { lang: this.lang, $http: this.$http });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.rand.length = 9;
    this.getData();
    setTimeout(function () {
      _this.typesAnimation = !_this.typesAnimation;
    }, 3000);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'langs',
  data: function data() {
    return {
      browser: __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect___default()()
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang'
  }),
  methods: {
    setLang: function setLang(currentLang) {
      this.$store.commit('SET_LANG', currentLang);
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu__ = __webpack_require__(152);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  components: { NavigationMenu: __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu__["a" /* default */] },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang'
  }),
  watch: {
    lang: function lang() {
      this.getData();
    }
  },
  created: function created() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      this.$store.dispatch('fetchNavigation', { lang: this.lang, $http: this.$http });
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_getKeyByValue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_getKeyByValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helpers_getKeyByValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  props: ['parent'],
  data: function data() {
    return {
      duration: 2000,
      keyFinder: __WEBPACK_IMPORTED_MODULE_1__helpers_getKeyByValue___default.a,
      browser: __WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect___default()()
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    menu: 'navigation',
    pageReady: 'pageReady',
    menuExpanded: 'menuExpanded',
    currentPage: 'currentPage'
  }),
  mounted: function mounted() {
    var _this = this;

    if (location.pathname && location.pathname !== '/') {
      var currentID = location.pathname.replace(/\//g, '');
      var waitContent = setInterval(function () {
        if (_this.pageReady) {
          _this.scrollTo(currentID);
          clearInterval(waitContent);
        }
      }, 100);
    }
  },

  methods: {
    disableScrollListener: function disableScrollListener() {
      var _this2 = this;

      this.$store.commit('PAGE_IS_AUTO_SCROLLING', true);
      if (this.browser === 'ie') {
        this.$store.commit('PAGE_IS_AUTO_SCROLLING', false);
      } else {
        setTimeout(function () {
          _this2.$store.commit('PAGE_IS_AUTO_SCROLLING', false);
        }, this.duration - 200);
      }
    },
    scrollTo: function scrollTo(id) {
      var element = document.getElementById(id);
      this.disableScrollListener();
      if (element) this.$SmoothScroll(element, this.duration);
      this.$store.commit('CHANGE_MENU_STATE', false);
    },
    isShown: function isShown(listItem) {
      return listItem.is_published === '1' && listItem.is_show_in_menu === '1';
    },
    setCurrentTab: function setCurrentTab(tabName) {
      this.$store.commit('SET_CURRENT_TAB', tabName);
      this.$store.commit('CHANGE_MENU_STATE', false);
    },
    getSubLists: function getSubLists(menu, li) {
      var _this3 = this;

      var filteredMenu = menu.filter(function (el) {
        var isSub = el.parent_id === li.object_id && _this3.isShown(el);
        return isSub;
      });
      return filteredMenu;
    },
    isCurrent: function isCurrent(path) {
      var isCurrentItem = this.currentPage === path || this.currentPage === path.concat('-content');
      return isCurrentItem;
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_prettifyDay__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_prettifyDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helpers_prettifyDay__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newsList',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    currentArticleIndex: 'currentArticleIndex',
    news: 'news',
    popupOpened: 'popupOpened'
  }), {
    currArr: function newCurrentArticleIndex() {
      return this.news.item[this.currentArticleIndex];
    }
  }),
  methods: {
    resetCurrentArticle: function resetCurrentArticle() {
      this.$store.commit('SET_CURRENT_ARTICLE', '');
      this.$store.commit('SET_POPUP_STATE', false);
    },
    changeCurrentArticle: function changeCurrentArticle(index) {
      if (index >= 0 && index < this.news.item.length) {
        this.$refs.articleFull.scrollTop = 0;
        this.$store.commit('SET_CURRENT_ARTICLE', index);
      }
    },
    setDay: function setDay(day) {
      return __WEBPACK_IMPORTED_MODULE_2__helpers_prettifyDay___default()(day);
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27 && _this.currentArticleIndex !== '') {
        _this.resetCurrentArticle();
      }
    });
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitleContent__ = __webpack_require__(13);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pageTitle',
  props: ['titleValue', 'isActive'],
  components: {
    PageTitleContent: __WEBPACK_IMPORTED_MODULE_1__components_PageTitleContent__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    pageReady: 'pageReady'
  })
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pageTitleContent',
  props: ['titleValue', 'isActive'],
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    pageReady: 'pageReady'
  }),
  data: function data() {
    return {
      words: this.titleValue.split(' ')
    };
  },

  watch: {
    titleValue: function titleValue() {
      var _this = this;

      if (this.titleValue) {
        this.words = [];
        setTimeout(function () {
          _this.words = _this.titleValue.split(' ');
        }, 100);
      }
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'projects',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    page: 'page',
    projects: 'projects',
    popupOpened: 'popupOpened',
    currentProject: 'currentProject'
  }),
  data: function data() {
    return {
      isExpanded: false
    };
  },

  props: ['project'],
  methods: {
    isCurrentProject: function isCurrentProject(id) {
      return id === this.currentProject;
    },
    expandElement: function expandElement(id, event) {
      var _this = this;

      var currentElem = event.currentTarget;
      if (!this.popupOpened) {
        this.$store.commit('SET_POPUP_STATE', true);
      }
      setTimeout(function () {
        _this.$SmoothScroll(currentElem, 500);
      }, 150);
      this.$store.commit('SET_CURRENT_PROJECT', id);
    },
    resetProject: function resetProject() {
      this.$store.commit('SET_CURRENT_PROJECT', '');
      this.$store.commit('SET_POPUP_STATE', false);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27 && _this2.currentProject !== '') {
        _this2.resetProject();
      }
    });
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Investors__ = __webpack_require__(149);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tabs',
  props: ['content'],
  data: function data() {
    return {
      currentIndex: 'company'
    };
  },

  components: { Investors: __WEBPACK_IMPORTED_MODULE_2__components_Investors__["a" /* default */] },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    projects: 'projects',
    currentTab: 'currentTab'
  }),
  methods: {
    setCurrentTab: function setCurrentTab(tab) {
      this.$store.commit('SET_CURRENT_TAB', tab);
      this.currentIndex = tab;
    },
    isIE: function isIE() {
      var ieCheck = __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect___default()() === 'ie';
      return ieCheck;
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'videoContainer',
  props: ['currentPage'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    mobile: 'mobile'
  }), {
    currentClass: function currentClass() {
      return 'video-container_'.concat(this.currentPage);
    }
  }),
  data: function data() {
    return {
      isEdge: false
    };
  },

  methods: {
    isActive: function isActive(item) {
      var checkVideo = this.$refs['video_' + item];
      var videoIsShown = this.currentPage === item;

      if (videoIsShown && checkVideo && checkVideo.playing) return videoIsShown;

      if (videoIsShown && checkVideo && !this.mobile) {
        checkVideo.style.display = 'block';
        checkVideo.play();
      }

      if (!videoIsShown && checkVideo && checkVideo.playing) {
        setTimeout(function () {
          checkVideo.pause();
          checkVideo.style.display = 'none';
        }, 1000);
      }

      return videoIsShown;
    },
    setPageLoadedAndReady: function setPageLoadedAndReady() {
      var _this = this;

      this.$store.commit('LOADED_PAGE', true);

      setTimeout(function () {
        _this.$store.commit('READY_PAGE', true);
      }, 1200);
    },
    edgeDetector: function edgeDetector() {
      var edgeCheck = __WEBPACK_IMPORTED_MODULE_2__helpers_browserDetect___default()() === 'edge';
      return edgeCheck;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.isEdge = this.edgeDetector();
    if (!this.mobile) {
      this.$refs.video_home.addEventListener('loadeddata', function () {
        _this2.setPageLoadedAndReady();
      }, false);
    } else if (this.$refs.video_home) {
      this.setPageLoadedAndReady();
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_AboutCompany__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_AboutStrategy__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AboutInvestors__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_WhyElbrusCapital__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tabs__ = __webpack_require__(155);
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  data: function data() {
    return {
      firstTab: __WEBPACK_IMPORTED_MODULE_1__pages_AboutCompany__["a" /* default */],
      secondTab: __WEBPACK_IMPORTED_MODULE_2__pages_AboutStrategy__["a" /* default */],
      thirdTab: __WEBPACK_IMPORTED_MODULE_3__pages_AboutInvestors__["a" /* default */],
      fourthTab: __WEBPACK_IMPORTED_MODULE_4__pages_WhyElbrusCapital__["a" /* default */]
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage'
  }),
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_5__components_Tabs__["a" /* default */],
    AboutCompany: __WEBPACK_IMPORTED_MODULE_1__pages_AboutCompany__["a" /* default */],
    AboutStrategy: __WEBPACK_IMPORTED_MODULE_2__pages_AboutStrategy__["a" /* default */],
    AboutInvestors: __WEBPACK_IMPORTED_MODULE_3__pages_AboutInvestors__["a" /* default */],
    WhyElbrusCapital: __WEBPACK_IMPORTED_MODULE_4__pages_WhyElbrusCapital__["a" /* default */]
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aboutCompany',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page'
  })
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aboutInvestors',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page'
  })
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aboutStrategy',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page'
  })
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contacts',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage'
  }),
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === this.page.contacts.$path;
      var animationTime = this.page.contacts.title.length * 70 + 900;
      setTimeout(function () {
        if (checkActive) {
          _this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'error',
  data: function data() {
    return {
      title: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  watch: {
    page: function page() {
      this.title = this.page.error.title;
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page'
  }),
  mounted: function mounted() {
    this.$store.dispatch('fetchPage', { lang: this.lang, $http: this.$http });
    this.$store.commit('SET_ERROR_PAGE_STATE', true);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'errorServer',
  data: function data() {
    return {
      title: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  watch: {
    page: function page() {
      this.title = this.page.errorserver.title;
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page'
  }),
  mounted: function mounted() {
    this.$store.dispatch('fetchPage', { lang: this.lang, $http: this.$http });
    this.$store.commit('SET_ERROR_PAGE_STATE', true);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Description__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'founders',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */],
    Description: __WEBPACK_IMPORTED_MODULE_2__components_Description__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    persons: 'persons',
    pageIsAutoScrolling: 'pageIsAutoScrolling'
  }),
  methods: {
    isActive: function isActive() {
      var _this = this;

      // const checkActive
      // this.currentPage === this.page.founders.$path || this.pageIsAutoScrolling;
      var checkActive = this.currentPage === this.page.founders.$path;
      var animationTime = this.page.founders.title.length * 70 + 900;
      setTimeout(function () {
        if (checkActive) {
          _this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitleContent__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'foundersContent',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  components: {
    PageTitleContent: __WEBPACK_IMPORTED_MODULE_1__components_PageTitleContent__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    pageReady: 'pageReady',
    currentPage: 'currentPage',
    pageIsAutoScrolling: 'pageIsAutoScrolling',
    persons: 'persons'
  }),
  watch: {
    lang: function lang() {
      this.getData();
    }
  },
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === 'founders-content';
      var animationTime = 3500;
      if (!this.pageIsAutoScrolling) {
        setTimeout(function () {
          if (checkActive) {
            _this.isAnimated = true;
          }
        }, animationTime);
      }
      return checkActive;
    },
    getData: function getData() {
      this.$store.dispatch('fetchPersons', { lang: this.lang, $http: this.$http });
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageTitleContent__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Description__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoContainer__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterComponent__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_About__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Team__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_TeamContent__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Founders__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_FoundersContent__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Portfolio__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_PortfolioContent__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_News__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_PrivateEquity__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_PrivateEquityContent__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Contacts__ = __webpack_require__(161);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      subTitle: false,
      isAnimated: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    pageReady: 'pageReady',
    currentPage: 'currentPage',
    popupOpened: 'popupOpened',
    pageIsAutoScrolling: 'pageIsAutoScrolling'
  }),
  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */],
    PageTitleContent: __WEBPACK_IMPORTED_MODULE_2__components_PageTitleContent__["a" /* default */],
    Description: __WEBPACK_IMPORTED_MODULE_3__components_Description__["a" /* default */],
    VideoContainer: __WEBPACK_IMPORTED_MODULE_4__components_VideoContainer__["a" /* default */],
    FooterComponent: __WEBPACK_IMPORTED_MODULE_5__components_FooterComponent__["a" /* default */],
    About: __WEBPACK_IMPORTED_MODULE_6__pages_About__["a" /* default */],
    Team: __WEBPACK_IMPORTED_MODULE_7__pages_Team__["a" /* default */],
    TeamContent: __WEBPACK_IMPORTED_MODULE_8__pages_TeamContent__["a" /* default */],
    Founders: __WEBPACK_IMPORTED_MODULE_9__pages_Founders__["a" /* default */],
    FoundersContent: __WEBPACK_IMPORTED_MODULE_10__pages_FoundersContent__["a" /* default */],
    Portfolio: __WEBPACK_IMPORTED_MODULE_11__pages_Portfolio__["a" /* default */],
    PortfolioContent: __WEBPACK_IMPORTED_MODULE_12__pages_PortfolioContent__["a" /* default */],
    News: __WEBPACK_IMPORTED_MODULE_13__pages_News__["a" /* default */],
    PrivateEquity: __WEBPACK_IMPORTED_MODULE_14__pages_PrivateEquity__["a" /* default */],
    PrivateEquityContent: __WEBPACK_IMPORTED_MODULE_15__pages_PrivateEquityContent__["a" /* default */],
    Contacts: __WEBPACK_IMPORTED_MODULE_16__pages_Contacts__["a" /* default */]
  },
  watch: {
    lang: function lang() {
      this.getData();
    }
  },
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === this.page.home.$path && !this.pageIsAutoScrolling;
      var animationTime = this.page.home.title.length * 70 + 5000;
      setTimeout(function () {
        if (checkActive) {
          _this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    },
    isSubTitle: function isSubTitle() {
      var _this2 = this;

      return setTimeout(function () {
        _this2.subTitle = true;
        return true;
      }, 1000);
    },
    closePopup: function closePopup() {
      this.$store.commit('SET_CURRENT_PERSON', '');
      this.$store.commit('SET_CURRENT_PROJECT', '');
      this.$store.commit('SET_CURRENT_ARTICLE', '');
      this.$store.commit('SET_POPUP_STATE', false);
    },
    getData: function getData() {
      this.$store.dispatch('fetchPage', { lang: this.lang, $http: this.$http });
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NewsPopup__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_prettifyDay__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_prettifyDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helpers_prettifyDay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(111);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newsList',
  data: function data() {
    return {
      isAnimated: false,
      swiperOption: {
        direction: 'horizontal',
        speed: 500,
        paginationClickable: true,
        keyboardControl: true,
        grabCursor: true,
        slidesPerView: 3,
        spaceBetween: 0,
        mousewheelControl: false,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next'
      }
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */],
    NewsPopup: __WEBPACK_IMPORTED_MODULE_2__components_NewsPopup__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    news: 'news'
  }),
  watch: {
    lang: function lang() {
      this.getData();
    }
  },
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === this.page.news.$path;
      var animationTime = this.page.news.title.length * 70 + 2000;
      setTimeout(function () {
        if (checkActive) {
          _this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    },
    slidersNumChange: function slidersNumChange() {
      if (window.innerWidth < 800) {
        this.swiperOption.slidesPerView = 1;
      } else {
        this.swiperOption.slidesPerView = 3;
      }
    },
    setCurrentArticleID: function setCurrentArticleID(index) {
      this.$store.commit('SET_CURRENT_ARTICLE', index);
      this.$store.commit('SET_POPUP_STATE', true);
    },
    getData: function getData() {
      this.$store.dispatch('fetchNews', { lang: this.lang, $http: this.$http });
    },
    setDay: function setDay(day) {
      return __WEBPACK_IMPORTED_MODULE_3__helpers_prettifyDay___default()(day);
    }
  },
  mounted: function mounted() {
    this.slidersNumChange();
    window.addEventListener('resize', this.slidersNumChange);
    this.getData();
  },
  beforeDestroy: function beforeDestroy() {
    window.addEventListener('resize', this.slidersNumChange);
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Description__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'portfolio',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */],
    Description: __WEBPACK_IMPORTED_MODULE_2__components_Description__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage'
  }),
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === this.page.portfolio.$path;
      var animationTime = this.page.portfolio.title.length * 70 + 900;
      setTimeout(function () {
        if (checkActive) {
          _this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Project__ = __webpack_require__(154);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'portfolioContent',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  watch: {
    lang: function lang() {
      this.getData();
    }
  },
  components: {
    Project: __WEBPACK_IMPORTED_MODULE_1__components_Project__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    projects: 'projects'
  }),
  methods: {
    getData: function getData() {
      this.$store.dispatch('fetchProjects', { lang: this.lang, $http: this.$http });
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Description__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privateEquity',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */],
    Description: __WEBPACK_IMPORTED_MODULE_2__components_Description__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage'
  }),
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === this.page.privateequity.$path;
      var animationTime = this.page.privateequity.title.length * 70 + 900;
      setTimeout(function () {
        if (checkActive) {
          _this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privateEquityContent',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage'
  }),
  methods: {
    isActive: function isActive() {
      var _this = this;

      var checkActive = this.currentPage === this.page.privateequity.$path;
      var animationTime = this.page.privateequity.title.length * 70 + 1300;
      setTimeout(function () {
        if (checkActive) _this.isAnimated = true;
      }, animationTime);
      return checkActive;
    },
    isIE: function isIE() {
      var ieCheck = __WEBPACK_IMPORTED_MODULE_1__helpers_browserDetect___default()() === 'ie';
      return ieCheck;
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Description__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'team',
  data: function data() {
    return {
      isAnimated: false
    };
  },

  components: {
    PageTitle: __WEBPACK_IMPORTED_MODULE_1__components_PageTitle__["a" /* default */],
    Description: __WEBPACK_IMPORTED_MODULE_2__components_Description__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    persons: 'persons',
    currentPerson: 'currentPerson',
    pageIsAutoScrolling: 'pageIsAutoScrolling'
  }),
  methods: {
    isActive: function isActive() {
      var _this = this;

      // const checkActive = this.currentPage === this.page.team.$path || this.pageIsAutoScrolling;
      var checkActive = this.currentPage === this.page.team.$path;
      var animationTime = this.page.team.title.length * 70 + 900;
      if (!this.pageIsAutoScrolling) {
        setTimeout(function () {
          if (checkActive) {
            _this.isAnimated = true;
          }
        }, animationTime);
      }
      return checkActive;
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_waterfall_lib_waterfall__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_waterfall_lib_waterfall_slot__ = __webpack_require__(177);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'teamContent',
  data: function data() {
    return {
      isAnimated: false,
      cardSize: 2,
      personClicked: '',
      currentTop: 0,
      oldTop: 0
    };
  },

  components: {
    Waterfall: __WEBPACK_IMPORTED_MODULE_1_vue_waterfall_lib_waterfall__["a" /* default */],
    WaterfallSlot: __WEBPACK_IMPORTED_MODULE_2_vue_waterfall_lib_waterfall_slot__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    persons: 'persons',
    currentPerson: 'currentPerson',
    popupOpened: 'popupOpened',
    pageIsAutoScrolling: 'pageIsAutoScrolling'
  }),
  watch: {
    lang: function lang() {
      this.getData();
    },
    popupOpened: function popupOpened() {
      if (!this.popupOpened) {
        this.resetCurrentPerson();
      }
    }
  },
  methods: {
    getPersonsCardSize: function getPersonsCardSize(size) {
      var currentClass = '';

      if (size === 1.2) {
        currentClass = 'small';
      } else if (size === 1.5) {
        currentClass = 'medium';
      } else if (size === 1.6) {
        currentClass = 'large';
      }

      return currentClass;
    },
    isCurrentPerson: function isCurrentPerson(id) {
      return id === this.currentPerson;
    },
    setCurrentTop: function setCurrentTop() {
      var teamTop = document.querySelector('.team').getBoundingClientRect().top;
      this.currentTop = -teamTop + 100;
    },
    setCurrentPerson: function setCurrentPerson(id) {
      this.$store.commit('SET_CURRENT_PERSON', id);
      this.oldTop = this.$refs['' + id][0].$el.style.top;
      this.personClicked = id;
      this.setCurrentTop();
      this.$store.commit('SET_POPUP_STATE', true);
    },
    resetCurrentPerson: function resetCurrentPerson() {
      var _this = this;

      this.$store.commit('SET_CURRENT_PERSON', '');
      this.$store.commit('SET_POPUP_STATE', false);
      this.$refs.waterfall.$emit('reflow');
      setTimeout(function () {
        _this.personClicked = '';
      }, 1000);
    },
    checkCurrentPerson: function checkCurrentPerson(person) {
      if (this.isCurrentPerson(person.$id) && this.popupOpened) {
        return 'top: ' + this.currentTop + 'px';
      }
      return 'top: ' + this.oldTop + 'px';
    },
    getData: function getData() {
      this.$store.dispatch('fetchPersons', { lang: this.lang, $http: this.$http });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getData();
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27 && _this2.currentPerson !== '') {
        _this2.resetCurrentPerson();
      }
    });
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'whyElbrusCapital',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    lang: 'lang',
    page: 'page'
  })
});

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterComponent_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d09992a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterComponent_vue__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d09992a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FooterComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderComponent_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb51fb9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderComponent_vue__ = __webpack_require__(184);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb51fb9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Investors_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e047de38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Investors_vue__ = __webpack_require__(211);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e047de38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Investors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e047de38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Investors_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Langs_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50de89ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Langs_vue__ = __webpack_require__(193);
function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50de89ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Langs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50de89ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Langs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_817f084a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_817f084a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationMenu_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cc574c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationMenu_vue__ = __webpack_require__(182);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12cc574c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cc574c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationMenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsPopup_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da296bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NewsPopup_vue__ = __webpack_require__(196);
function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da296bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NewsPopup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615c0662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615c0662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57002f85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__ = __webpack_require__(194);
function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57002f85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoContainer_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcf7e8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_VideoContainer_vue__ = __webpack_require__(208);
function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bcf7e8e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcf7e8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_VideoContainer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b38120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(191);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b38120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutCompany_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba3e09d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AboutCompany_vue__ = __webpack_require__(187);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ba3e09d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutCompany_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba3e09d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AboutCompany_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutInvestors_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d48f1fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AboutInvestors_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d48f1fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutInvestors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d48f1fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AboutInvestors_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutStrategy_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe8424fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AboutStrategy_vue__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe8424fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutStrategy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe8424fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AboutStrategy_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28cbc80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__(206);
function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a28cbc80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28cbc80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623803cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623803cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorServer_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b44000e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorServer_vue__ = __webpack_require__(186);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b44000e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorServer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b44000e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorServer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Founders_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf8748de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Founders_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf8748de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Founders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf8748de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Founders_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoundersContent_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004eb150_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FoundersContent_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-004eb150"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoundersContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004eb150_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FoundersContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_794f82cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_794f82cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d240280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(188);
function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d240280"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d240280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b06c23aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__ = __webpack_require__(207);
function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b06c23aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioContent_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e905904_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioContent_vue__ = __webpack_require__(205);
function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e905904_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateEquity_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50569d8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateEquity_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50569d8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateEquity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50569d8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateEquity_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateEquityContent_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c9181e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateEquityContent_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateEquityContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c9181e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateEquityContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d5e14a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32d5e14a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d5e14a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamContent_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0528ef7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TeamContent_vue__ = __webpack_require__(180);
function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0528ef7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TeamContent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WhyElbrusCapital_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd394dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WhyElbrusCapital_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd394dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WhyElbrusCapital_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd394dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_WhyElbrusCapital_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2e7b649e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__(189);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2e7b649e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7e4a44db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__(201);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7e4a44db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waterfall_slot_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0b173776_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_waterfall_slot_vue__ = __webpack_require__(181);
function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waterfall_slot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0b173776_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_waterfall_slot_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waterfall_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8290d454_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_waterfall_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_waterfall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8290d454_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_waterfall_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.founders) ? _c('div', {
    class: [{
      'active': _vm.currentPage == 'founders-content' || _vm.pageIsAutoScrolling
    }, {
      'static': _vm.isAnimated
    }],
    attrs: {
      "id": "founders-content"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('div', {
    staticClass: "content content_founders light-bg"
  }, [_c('div', {
    staticClass: "founders"
  }, _vm._l((_vm.persons.item), function(person) {
    return (person.$is_founder) ? _c('div', {
      staticClass: "founder"
    }, [_c('div', {
      staticClass: "founder__photo",
      style: (("background-image: url(" + (person.background ? person.background.$src : '/f/dist/static/img/noimage.jpg') + ")"))
    }), _vm._v(" "), _c('div', {
      staticClass: "founder__info"
    }, [_c('div', {
      staticClass: "founder__name animated-title",
      class: {
        'animating': _vm.pageReady
      }
    }, [_c('PageTitleContent', {
      class: {
        'static': _vm.isAnimated
      },
      attrs: {
        "isActive": _vm.isActive(),
        "isAnimated": _vm.isAnimated,
        "titleValue": person.text.item.first_name
      }
    }), _c('PageTitleContent', {
      class: {
        'static': _vm.isAnimated
      },
      attrs: {
        "isActive": _vm.isActive(),
        "isAnimated": _vm.isAnimated,
        "titleValue": person.text.item.last_name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "founder__content",
      domProps: {
        "innerHTML": _vm._s(person.text.item.text_content)
      }
    })])]) : _vm._e()
  }))])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.team) ? _c('div', {
    class: {
      'active': _vm.currentPage == 'team-content' || this.pageIsAutoScrolling
    },
    attrs: {
      "id": "team-content"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('div', {
    staticClass: "content content_team light-bg"
  }, [_c('div', {
    staticClass: "team"
  }, [_c('waterfall', {
    ref: "waterfall",
    attrs: {
      "line-gap": 380,
      "align": "center",
      "watch": _vm.persons
    }
  }, _vm._l((_vm.persons.item), function(person, index) {
    return (!person.$is_founder) ? _c('waterfall-slot', {
      key: person.$id,
      ref: person.$id,
      refInFor: true,
      class: [_vm.isCurrentPerson(person.$id) && _vm.popupOpened ? 'selected' : 'deselected', _vm.getPersonsCardSize(person.card_size.$size)],
      style: (_vm.checkCurrentPerson(person)),
      attrs: {
        "width": 330,
        "height": 330 * person.card_size.$size,
        "order": index
      }
    }, [_c('div', {
      staticClass: "person",
      on: {
        "click": function($event) {
          _vm.setCurrentPerson(person.$id)
        }
      }
    }, [_c('span', {
      staticClass: "person__back",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.resetCurrentPerson()
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-left"
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-exit"
    })]), _vm._v(" "), (person.background) ? _c('div', {
      staticClass: "person__photo",
      style: ({
        backgroundImage: 'url(' + person.background.$src + ')'
      })
    }, [(person.photo) ? _c('div', {
      staticClass: "person__photo-img",
      style: ({
        backgroundImage: 'url(' + person.photo.$src + ')'
      })
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "person__info"
    }, [_c('div', {
      staticClass: "person__name"
    }, [_vm._v("\n                    " + _vm._s(person.text.item.first_name) + " " + _vm._s(person.text.item.last_name) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "person__position"
    }, [_vm._v("\n                    " + _vm._s(person.text.item.position) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "person__content",
      domProps: {
        "innerHTML": _vm._s(person.text.item.text_content)
      }
    })])])]) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "team__contacts",
    domProps: {
      "innerHTML": _vm._s(_vm.page.team.text_contacts)
    }
  })])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "vue-waterfall-slot"
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "navigation",
    class: {
      'animated': _vm.pageReady
    }
  }, _vm._l((_vm.menu), function(li, key) {
    return (li.full_path !== '/' && _vm.isShown(li) && li.parent_id === _vm.parent) ? _c('li', {
      class: {
        'selected': _vm.isCurrent(li.path)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.scrollTo(li.path)
        }
      }
    }, [_c('span', [_c('router-link', {
      style: (("animation-delay: " + ((key * 100)/1000) + "s")),
      attrs: {
        "to": ("/" + (li.path))
      }
    }, [_vm._v(_vm._s(li.name))])], 1), _vm._v(" "), (_vm.keyFinder(_vm.menu, li.object_id)) ? _c('ul', _vm._l((_vm.getSubLists(_vm.menu, li)), function(subli, key2) {
      return _c('li', {
        on: {
          "click": function($event) {
            _vm.setCurrentTab(subli.path)
          }
        }
      }, [_c('span', {
        style: (("animation-delay: " + ((key2 * 70)/1000) + "s"))
      }, [_vm._v(_vm._s(subli.name))])])
    })) : _vm._e()]) : _vm._e()
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      'app-autoscrolling': _vm.pageIsAutoScrolling
    }, 'app-' + _vm.browser],
    attrs: {
      "id": "app"
    }
  }, [(!_vm.pageReady && !_vm.isErrorPage) ? [_c('transition', {
    attrs: {
      "name": "preloader-fade"
    }
  }, [_c('div', {
    staticClass: "preloader-container"
  }, [_c('div', {
    staticClass: "preloader-inner"
  }, [_c('div', {
    staticClass: "preloader",
    class: {
      'animated': _vm.pageLoaded
    }
  }, [_c('svg', {
    attrs: {
      "width": "103",
      "height": "49",
      "viewBox": "0 0 103 49"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M54.924 21.546h3.58l-7.85-8.12c3.29-.187 6.126-2.438 6.126-6.084 0-3.912-2.89-6.163-6.76-6.163H44.21v20.366h2.546v-8.683l8.166 8.683zM46.758 3.43h3.208c2.65 0 4.27 1.554 4.27 3.94 0 2.223-1.354 3.94-5.25 3.94-1.512 0-1.884 0-2.228-.028V3.43zm14.184 10.72c0 4.394 3.287 7.718 7.848 7.718 4.667 0 7.954-3.324 7.954-7.72V1.18H74.2V13.4c0 3.324-1.83 6.058-5.357 6.058-3.526 0-5.356-2.734-5.356-6.057V1.18h-2.545v12.97zm31.684-7.156c-.292-4.127-2.89-6.137-6.23-6.137-3.315 0-6.205 2.117-6.205 5.628 0 2.626 1.485 4.395 4.48 5.574l2.573 1.018c1.83.723 3.13 1.74 3.13 3.323 0 1.796-1.592 3.216-3.792 3.216-2.836 0-3.95-1.554-4.162-3.778h-2.546c.32 4.074 2.917 6.03 6.576 6.03 3.87 0 6.47-2.385 6.47-5.68 0-2.467-1.486-4.37-4.693-5.576l-2.546-.965c-1.99-.75-2.944-1.715-2.944-3.242 0-1.394.77-3.297 3.633-3.297 2.146 0 3.525 1.474 3.87 3.886h2.386z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M1.075 21.546h10.42v-2.412H3.62V12.46h7.875v-2.41H3.62V3.59h7.875V1.18H1.075v20.366zm13.893 0h9.625v-2.412h-7.08V1.18H14.97v20.366zm12.41 0h7.29c3.393 0 6.07-2.438 6.07-5.762 0-2.466-1.43-4.53-3.923-4.904v-.053c1.512-.75 2.52-2.118 2.52-4.02 0-2.064-.93-3.538-2.175-4.45-1.193-.857-2.545-1.178-4.534-1.178h-5.25v20.366zm2.544-2.25V12.3h3.87c3.42 0 4.402 1.903 4.402 3.51 0 1.85-.98 3.485-4.4 3.485H29.92zm0-9.247V3.43H32.6c1.485 0 2.518.32 3.18.938.638.59 1.01 1.447 1.01 2.492 0 1.983-1.618 3.19-3.687 3.19h-3.18zM17.72 30.443c-1.618-1.5-4.242-2.6-6.92-2.6C3.96 27.845.117 33.312.117 38.35c0 5.038 3.844 10.504 10.683 10.504 2.545 0 5.196-1.072 6.998-2.733l-1.617-1.85c-1.404 1.34-3.153 2.17-5.38 2.17-4.11 0-7.98-3.35-7.98-8.092 0-4.69 3.765-8.092 7.98-8.092 1.935 0 3.765.777 5.196 2.09l1.723-1.902zM34.896 48.53h2.783l-8.19-20.364H27.26l-8.19 20.365h2.782l1.83-4.742h9.384l1.83 4.743zm-2.704-6.993h-7.635l3.818-9.995 3.817 9.995zm8.138 6.994h2.546v-6.94h3.022c4.268 0 6.812-3.295 6.812-6.698 0-3.403-2.544-6.726-6.812-6.726H40.33V48.53zm2.546-9.19v-8.923h2.492c3.048 0 4.798 1.528 4.798 4.475 0 2.947-1.75 4.448-4.798 4.448h-2.492zm12.697 9.19h2.545V28.167h-2.545V48.53zm10.18 0h2.544V30.58h5.037v-2.412H60.716v2.412h5.037V48.53zm22.166 0H90.7l-8.19-20.364h-2.227L72.093 48.53h2.784l1.83-4.742h9.383l1.83 4.743zm-2.705-6.993H77.58l3.818-9.995 3.817 9.995zm8.138 6.994h9.623v-2.41h-7.078V28.165h-2.545V48.53z"
    }
  })])])])])])])] : _vm._e(), _vm._v(" "), (!_vm.isErrorPage) ? _c('HeaderComponent') : _vm._e(), _vm._v(" "), _c('router-view')], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.home) ? _c('div', {
    staticClass: "header",
    class: {
      'expanded': _vm.menuExpanded, 'reduced': _vm.reducedMenu
    }
  }, [_c('div', {
    staticClass: "header__inner"
  }, [(_vm.page.home.logo) ? _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.page.home.logo.img.$src,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "burger",
    on: {
      "click": function($event) {
        _vm.expandMenu()
      }
    }
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "navigation-container"
  }, [(_vm.page.home.logo) ? _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.page.home.logo.img.$src,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('span', {
    staticClass: "navigation__close",
    on: {
      "click": function($event) {
        _vm.expandMenu()
      }
    }
  }, [_vm._v("×")])], 1), _vm._v(" "), _c('Langs')], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description",
    class: {
      'description_animating': _vm.pageReady && _vm.isActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.descrValue)
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.errorserver) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "error__inner"
  }, [_c('div', {
    staticClass: "error__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.errorserver.text_error_status)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error__text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.errorserver.text_error_title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.errorserver.text_error_text)
    }
  })])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.news) ? _c('div', {
    class: {
      'active': _vm.currentPage == _vm.page.news.$path
    },
    attrs: {
      "id": _vm.page.news.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.news.title
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "news-wrapper",
    class: {
      'static': _vm.isAnimated
    }
  }, [_c('div', {
    staticClass: "swiper-controls"
  }, [_c('div', {
    staticClass: "swiper-button-prev icon-arrow-left",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next icon-arrow-right",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })]), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    staticClass: "news-list",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.news.item), function(article, index) {
    return _c('swiper-slide', {
      staticClass: "article"
    }, [_c('span', {
      staticClass: "article__pointer",
      style: (("transition-delay: " + ((index * 200)/1000) + "s"))
    }), _vm._v(" "), _c('div', {
      staticClass: "article__inner",
      style: (("animation-delay: " + ((index * 200)/1000) + "s")),
      on: {
        "click": function($event) {
          _vm.setCurrentArticleID(index)
        }
      }
    }, [_c('div', {
      staticClass: "article__date"
    }, [(article.publication_datetime.$day) ? _c('span', {
      staticClass: "article__day"
    }, [_vm._v(_vm._s(_vm.setDay(article.publication_datetime.$day)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "article__monthyear"
    }, [_c('span', {
      staticClass: "article__month"
    }, [_vm._v(_vm._s(_vm.$t('months', _vm.lang)[parseInt(article.publication_datetime.$month, 10) - 1]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.publication_datetime.$year))])])]), _vm._v(" "), _c('div', {
      staticClass: "article__summary",
      domProps: {
        "innerHTML": _vm._s(article.text.item.text_summary)
      }
    })])])
  }))], 1), _vm._v(" "), _c('NewsPopup')], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.team) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.team.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1,
        stickyTop: 0
      }),
      expression: "{ zIndex: 1, stickyTop: 0 }"
    }],
    staticClass: "section__top"
  }, [_c('div', [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.team.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.team.text_description,
      "isActive": _vm.isActive()
    }
  })], 1)])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.about) ? _c('div', {
    class: {
      'active': _vm.currentPage == _vm.page.about.$path
    },
    attrs: {
      "id": _vm.page.about.$path
    }
  }, [_c('div', {
    staticClass: "section section_about"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('Tabs', {
    attrs: {
      "content": [{
        text: _vm.page.about.company,
        comp: _vm.firstTab
      }, {
        text: _vm.page.about.strategy,
        comp: _vm.secondTab
      }, {
        text: _vm.page.about.investors,
        comp: _vm.thirdTab
      }, {
        text: _vm.page.about.whyelbruscapital,
        comp: _vm.fourthTab
      }]
    }
  })], 1)])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.privateequity) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.privateequity.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1,
        stickyTop: 0
      }),
      expression: "{ zIndex: 1, stickyTop: 0 }"
    }],
    staticClass: "section__top"
  }, [_c('div', [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.privateequity.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.privateequity.text_description,
      "isActive": _vm.isActive()
    }
  })], 1)])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langs"
  }, [_c('span', {
    staticClass: "lang",
    class: {
      'selected': _vm.lang === 'en', 'not-hovered': _vm.browser === 'ios'
    },
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_c('span', [_vm._v("En")])]), _vm._v(" "), _c('span', {
    staticClass: "lang",
    class: {
      'selected': _vm.lang === 'ru', 'not-hovered': _vm.browser === 'ios'
    },
    on: {
      "click": function($event) {
        _vm.setLang('ru')
      }
    }
  }, [_c('span', [_vm._v("Ru")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs__switchers"
  }, _vm._l((_vm.content), function(cont) {
    return _c('div', {
      staticClass: "tabs__switcher",
      class: {
        'selected': _vm.currentTab === cont.text.$path
      },
      on: {
        "click": function($event) {
          _vm.setCurrentTab(cont.text.$path)
        }
      }
    }, [_vm._v(" " + _vm._s(cont.text.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "tabs__contents"
  }, _vm._l((_vm.content), function(cont) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (cont.text.$path == _vm.currentTab),
        expression: "cont.text.$path ==currentTab"
      }],
      staticClass: "tabs__content",
      class: {
        'selected': _vm.currentTab === cont.text.$path
      }
    }, [(cont.text.text_left_col) ? _c('div', {
      staticClass: "cols cols_2"
    }, [_c('div', {
      staticClass: "col",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_left_col)
      }
    }), _vm._v(" "), (cont.text.text_right_col) ? _c('div', {
      staticClass: "col",
      class: {
        'static': _vm.isIE()
      },
      domProps: {
        "innerHTML": _vm._s(cont.text.text_right_col)
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (cont.text.text_content) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(cont.text.text_content)
      }
    }) : _vm._e(), _vm._v(" "), (cont.text.$path === 'investors') ? _c('div', [_c('Investors', {
      attrs: {
        "content": cont
      }
    })], 1) : _vm._e(), _vm._v(" "), (cont.text.$path === 'whyelbruscapital') ? _c('div', {
      staticClass: "elbrus-benefits"
    }, [(cont.text.text_benefit_1) ? _c('div', {
      staticClass: "elbrus-benefits__item",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_1)
      }
    }) : _vm._e(), _vm._v(" "), (cont.text.text_benefit_2) ? _c('div', {
      staticClass: "elbrus-benefits__item",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_2)
      }
    }) : _vm._e(), _vm._v(" "), (cont.text.text_benefit_3) ? _c('div', {
      staticClass: "elbrus-benefits__item"
    }, [_c('div', {
      staticClass: "cols cols_2"
    }, [_c('div', {
      staticClass: "col",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_3)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "companies"
    }, _vm._l((_vm.projects.item), function(project, key) {
      return (key < 5) ? _c('div', {
        staticClass: "companies__item",
        style: (("animation-name: companyAnimation" + (key + 1) + "; animation-delay: " + ((key * 900)/1000) + "s"))
      }, [(project.text.item.logo_black) ? _c('img', {
        attrs: {
          "src": project.text.item.logo_black.$src,
          "alt": ""
        }
      }) : _vm._e()]) : _vm._e()
    }))])])]) : _vm._e(), _vm._v(" "), (cont.text.text_benefit_4) ? _c('div', {
      staticClass: "elbrus-benefits__item",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_4)
      }
    }) : _vm._e()]) : _vm._e()])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadePopup"
    }
  }, [(_vm.currentArticleIndex !== '' && _vm.popupOpened) ? _c('div', {
    staticClass: "popup news-popup"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true
      }),
      expression: "{preventParentScroll: true}"
    }],
    staticClass: "popup__content light-bg"
  }, [_c('div', {
    ref: "articleFull",
    staticClass: "article-full"
  }, [_c('transition', {
    attrs: {
      "name": "fadePopup"
    }
  }, [_c('div', {
    staticClass: "article-full__content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currArr.text.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "article-full__date"
  }, [_vm._v("\n              " + _vm._s(_vm.setDay(_vm.currArr.publication_datetime.$day)) + "\n              " + _vm._s(_vm.$t("months")[parseInt(_vm.currArr.publication_datetime.$month, 10) - 1]) + "\n              " + _vm._s(_vm.currArr.publication_datetime.$year) + "\n            ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currArr.text.item.text_content)
    }
  })])])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "popup__close",
    on: {
      "click": _vm.resetCurrentArticle
    }
  }, [_c('span', {
    staticClass: "icon-exit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup__controls"
  }, [_c('span', {
    staticClass: "popup__control",
    class: {
      'disabled': _vm.currentArticleIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.changeCurrentArticle(_vm.currentArticleIndex - 1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "popup__control",
    class: {
      'disabled': _vm.currentArticleIndex === _vm.news.item.length - 1
    },
    on: {
      "click": function($event) {
        _vm.changeCurrentArticle(_vm.currentArticleIndex + 1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right"
  })])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.home) ? _c('div', {
    staticClass: "project",
    class: {
      'expanded': _vm.isCurrentProject(_vm.project.$id) && _vm.popupOpened
    }
  }, [_c('div', {
    staticClass: "project__content",
    on: {
      "click": function($event) {
        _vm.expandElement(_vm.project.$id, $event)
      }
    }
  }, [_c('div', {
    staticClass: "project__logo"
  }, [(_vm.project.text.item.logo) ? _c('img', {
    staticClass: "project__logo-img project__logo-img_color",
    attrs: {
      "src": _vm.project.text.item.logo.$src,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project.text.item.logo_bw) ? _c('img', {
    staticClass: "project__logo-img project__logo-img_white",
    attrs: {
      "src": _vm.project.text.item.logo_bw.$src,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project__info"
  }, [_c('div', {
    staticClass: "project__line project__title"
  }, [_vm._v(_vm._s(_vm.project.text.item.company_name))]), _vm._v(" "), _c('div', {
    staticClass: "project__line project__industry",
    domProps: {
      "innerHTML": _vm._s(_vm.project.text.item.text_industry)
    }
  }), _vm._v(" "), (_vm.project.$exited) ? _c('div', {
    staticClass: "project__line project__exited",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.project_status)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project__hidden light-bg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "project__close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetProject($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-exit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "project__top"
  }, [_c('div', {
    staticClass: "project__logo"
  }, [(_vm.project.text.item.logo) ? _c('img', {
    attrs: {
      "src": _vm.project.text.item.logo.$src,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project__info"
  }, [_c('div', {
    staticClass: "project__line project__title"
  }, [_vm._v(_vm._s(_vm.project.text.item.company_name))]), _vm._v(" "), _c('div', {
    staticClass: "project__line project__date"
  }, [_vm._v(_vm._s(_vm.project.$project_year))]), _vm._v(" "), _c('div', {
    staticClass: "project__line project__industry",
    domProps: {
      "innerHTML": _vm._s(_vm.project.text.item.text_industry)
    }
  }), _vm._v(" "), (_vm.project.$exited) ? _c('div', {
    staticClass: "project__line project__exited",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.project_status)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "project__text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.text.item.text_content)
    }
  }), _vm._v(" "), (_vm.project.$site_link) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.project.$site_link
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.project.$site_link.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '')))])]) : _vm._e()]), _vm._v(" "), (_vm.project.photo) ? _c('div', {
    staticClass: "project__photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.project.photo.large.$src,
      "alt": ""
    }
  })]) : _vm._e()])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.error) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "error__inner"
  }, [_c('div', {
    staticClass: "error__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.error.text_error_status)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error__text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.error.text_error_title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.error.text_error_text)
    }
  })])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.privateequity && (_vm.page.privateequity.text_left_col || _vm.page.privateequity.text_right_col)) ? _c('div', {
    class: {
      'active': _vm.currentPage == 'privateequity-content'
    },
    attrs: {
      "id": "privateequity-content"
    }
  }, [_c('div', {
    staticClass: "section reduced-width"
  }, [_c('div', {
    staticClass: "section__main"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "cols"
  }, [_c('div', {
    staticClass: "col col_main",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_left_col)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col col_extra",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_right_col)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "diagram-container",
    class: {
      'static': _vm.isIE()
    }
  }, [_c('div', {
    staticClass: "circles circles_1"
  }, [_c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_1))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_2"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "250",
      "height": "3",
      "viewBox": "0 0 250 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad1",
      "x1": "0",
      "y1": "0",
      "x2": "250",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "250",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad1)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_2))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_3"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "70",
      "height": "3",
      "viewBox": "0 0 70 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad2",
      "x1": "0",
      "y1": "0",
      "x2": "70",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "70",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad2)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_3))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_4"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "95",
      "height": "3",
      "viewBox": "0 0 95 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad3",
      "x1": "0",
      "y1": "0",
      "x2": "95",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "95",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad3)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_4))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_5"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "170",
      "height": "3",
      "viewBox": "0 0 170 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad4",
      "x1": "0",
      "y1": "0",
      "x2": "170",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "170",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad4)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_5))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_6"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "360",
      "height": "3",
      "viewBox": "0 0 360 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad5",
      "x1": "0",
      "y1": "0",
      "x2": "360",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "360",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad5)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_6))]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('div', {
    staticClass: "benefits__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_benefits_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cols"
  }, [_c('div', {
    staticClass: "col col_main",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_benefits_left_col)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col col_extra",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_benefits_right_col)
    }
  })])])])])])]) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    class: 'page_' + _vm.lang
  }, [_c('VideoContainer', {
    attrs: {
      "currentPage": _vm.currentPage
    }
  }), _vm._v(" "), (_vm.page.home) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.home.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__top"
  }, [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.home.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.home.text_description,
      "isActive": _vm.isActive()
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-extra",
    class: {
      'animating': _vm.pageReady && _vm.isSubTitle() && _vm.subTitle
    }
  }, [_c('div', {
    staticClass: "home-extra__item"
  }, [_c('div', {
    staticClass: "home-extra__item-title animated-title"
  }, [_c('PageTitleContent', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.home.text_extra_title_1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "home-extra__item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.text_extra_content_1)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "home-extra__item"
  }, [_c('div', {
    staticClass: "home-extra__item-title animated-title"
  }, [_c('PageTitleContent', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.home.text_extra_title_2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "home-extra__item-text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.home.text_extra_content_2)
    }
  })])])], 1)])])]) : _vm._e(), _vm._v(" "), _c('About'), _vm._v(" "), _c('Portfolio'), _vm._v(" "), _c('PortfolioContent'), _vm._v(" "), _c('Founders'), _vm._v(" "), _c('FoundersContent'), _vm._v(" "), _c('Team'), _vm._v(" "), _c('TeamContent'), _vm._v(" "), _c('News'), _vm._v(" "), _c('PrivateEquity'), _vm._v(" "), _c('PrivateEquityContent'), _vm._v(" "), _c('Contacts'), _vm._v(" "), (_vm.page.home) ? _c('FooterComponent', {
    attrs: {
      "copyright": _vm.page.home.text_footer_copy,
      "madeIn": _vm.page.home.text_footer_made_in
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popupOpened),
      expression: "popupOpened"
    }],
    staticClass: "fader",
    on: {
      "click": function($event) {
        _vm.closePopup()
      }
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('NavigationMenu', {
    attrs: {
      "parent": "7"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-waterfall",
    style: (_vm.style)
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer reduced-width"
  }, [_c('div', {
    staticClass: "footer__copy",
    domProps: {
      "innerHTML": _vm._s(_vm.copyright)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer__made-in",
    domProps: {
      "innerHTML": _vm._s(_vm.madeIn)
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.portfolio) ? _c('div', {
    class: {
      'active': _vm.currentPage == 'portfolio-content'
    },
    attrs: {
      "id": "portfolio-content"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('div', {
    staticClass: "portfolio"
  }, _vm._l((_vm.projects.item), function(project) {
    return _c('Project', {
      attrs: {
        "project": project
      }
    })
  }))])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.contacts) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.contacts.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.contacts.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts",
    class: {
      'static': _vm.isAnimated
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 320 390",
      "width": "320",
      "height": "390",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "0 0, 320 390, 0 390"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_advisor_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_advisor)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_environmental_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_environmental)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_issues_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_issues)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_press_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_press)
    }
  })])])])])])], 1)])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.portfolio) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.portfolio.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1,
        stickyTop: 0
      }),
      expression: "{ zIndex: 1, stickyTop: 0 }"
    }],
    staticClass: "section__top"
  }, [_c('div', [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.portfolio.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.portfolio.text_description,
      "isActive": _vm.isActive()
    }
  })], 1)])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container",
    class: [_vm.currentClass, {
      'video-container_edge': _vm.isEdge
    }]
  }, [(!_vm.mobile) ? [_c('video', {
    ref: "video_home",
    class: {
      'active': _vm.isActive('home')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.isActive('home'),
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/home.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/home.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/home.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_team",
    class: {
      'active': _vm.isActive('team')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'team',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/team.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/team.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/team.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_portfolio",
    class: {
      'active': _vm.isActive('portfolio')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'portfolio',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/portfolio.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/portfolio.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/portfolio.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_privateequity",
    class: {
      'active': _vm.isActive('privateequity')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'privateequity',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/privateequity.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/privateequity.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/privateequity.ogv",
      "type": "video/ogg"
    }
  })]), _vm._v(" "), _c('video', {
    ref: "video_founders",
    class: {
      'active': _vm.isActive('founders')
    },
    attrs: {
      "muted": "",
      "autoplay": _vm.currentPage === 'founders',
      "data-object-fit": "cover"
    }
  }, [_c('source', {
    attrs: {
      "src": "/f/dist/static/video/founders.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/founders.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/f/dist/static/video/founders.ogv",
      "type": "video/ogg"
    }
  })])] : [_c('img', {
    ref: "video_home",
    class: {
      'active': _vm.isActive('home')
    },
    attrs: {
      "src": "/f/dist/static/img/home.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_team",
    class: {
      'active': _vm.isActive('team')
    },
    attrs: {
      "src": "/f/dist/static/img/team.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_portfolio",
    class: {
      'active': _vm.isActive('portfolio')
    },
    attrs: {
      "src": "/f/dist/static/img/portfolio.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_privateequity",
    class: {
      'active': _vm.isActive('privateequity')
    },
    attrs: {
      "src": "/f/dist/static/img/privateequity.jpg",
      "data-object-fit": "cover"
    }
  }), _vm._v(" "), _c('img', {
    ref: "video_founders",
    class: {
      'active': _vm.isActive('founders')
    },
    attrs: {
      "src": "/f/dist/static/img/founders.jpg",
      "data-object-fit": "cover"
    }
  })]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.founders) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.founders.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1,
        stickyTop: 0
      }),
      expression: "{ zIndex: 1, stickyTop: 0 }"
    }],
    staticClass: "section__top"
  }, [_c('div', [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.founders.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.founders.text_description,
      "isActive": _vm.isActive()
    }
  })], 1)])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.text.text_investors_geography_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "investors-geography"
  }, _vm._l((_vm.investorsGeographies.item), function(geography, key1) {
    return _c('div', {
      staticClass: "investors-geography__item"
    }, [_c('div', {
      staticClass: "investors-geography__item-img"
    }, [_c('img', {
      style: (("animation-delay: " + ((key1 * 100)/1000) + "s")),
      attrs: {
        "src": geography.photo.$src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "investors-geography__item-percent"
    }, [_c('span', {
      staticClass: "percents",
      class: {
        'percents_double': String(geography.$percents).length > 1
      }
    }, [(String(geography.$percents)[0]) ? _c('span', {
      staticClass: "percents__line"
    }, _vm._l((_vm.rand), function(ind, key) {
      return (key >= parseInt(String(geography.$percents)[0], 10)) ? _c('span', {
        staticClass: "percents__num"
      }, [_vm._v("\n              " + _vm._s(key) + "\n            ")]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), (String(geography.$percents)[1] > 0) ? _c('span', {
      staticClass: "percents__line"
    }, _vm._l((_vm.rand), function(ind2, key2) {
      return (_vm.rand.length - key2 >= parseInt(String(geography.$percents)[1], 10)) ? _c('span', {
        staticClass: "percents__num"
      }, [_vm._v("\n              " + _vm._s(_vm.rand.length - key2) + "\n            ")]) : _vm._e()
    })) : _c('span', {
      staticClass: "percents__line"
    }, [_c('span', {
      staticClass: "percents__num"
    }, [_vm._v("\n              " + _vm._s(String(geography.$percents)[1]) + "\n            ")])])]), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "investors-geography__item-title"
    }, [_vm._v(_vm._s(geography.text.item.title))])])
  })), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.text.text_investors_types_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "investors-types",
    class: {
      'animated': _vm.typesAnimation
    }
  }, _vm._l((_vm.investorsTypes.item), function(type, key) {
    return _c('div', {
      staticClass: "investors-types__item"
    }, [_c('div', {
      staticClass: "investors-types__item-title"
    }, [_c('span', {
      style: (("animation-delay: " + ((key * 100)/1000) + "s"))
    }, [_vm._v("\n          " + _vm._s(type.text.item.title) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "investors-types__item-value",
      style: (("animation-delay: " + (((key + 1) * 170)/1000) + "s"))
    }, [_c('span', [_c('span', {
      style: ({
        width: type.$percents + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "investors-types__item-number"
    }, [_c('span', {
      style: (("animation-delay: " + (((key + 1) * 300)/1000) + "s"))
    }, [_vm._v(_vm._s(type.$percents) + "%")])])])
  }))])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "percents__sign"
  }, [_c('span', [_vm._v("%")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section__title animated-title",
    class: {
      'animating': _vm.pageReady
    }
  }, [_c('PageTitleContent', {
    attrs: {
      "isActive": _vm.isActive,
      "titleValue": _vm.titleValue
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._l((_vm.words), function(word) {
    return _c('span', {
      staticClass: "word nowrap"
    }, _vm._l((word), function(letter, key) {
      return (letter !== ' ') ? _c('span', {
        class: ['letter', {
          'letter_animated': _vm.isActive
        }, {
          'letter_wider': letter == 'f'
        }]
      }, [_c('span', {
        style: (("animation-delay: " + ((key * 70)/1000) + "s"))
      }, [_vm._v(_vm._s(letter))])]) : _vm._e()
    }))
  }), _vm._v(" "), (_vm.isActive) ? [_c('ins', {
    staticClass: "decor-line decor-line_hor1"
  }), _vm._v(" "), _c('ins', {
    staticClass: "decor-line decor-line_hor2"
  }), _vm._v(" "), _c('ins', {
    staticClass: "decor-line decor-line_vert1"
  }), _vm._v(" "), (_vm.titleValue.length > 10) ? [_c('ins', {
    staticClass: "decor-line decor-line_hor3"
  }), _vm._v(" "), _c('ins', {
    staticClass: "decor-line decor-line_vert2"
  })] : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[38]);


// WEBPACK FOOTER //
// static/js/app.js